import { PayloadAction } from '@reduxjs/toolkit';
import { CampaignDetailSlice } from './types';
import { REDUX_KEY } from '../../constants';

export const updateFieldReducer = (
  state: CampaignDetailSlice,
  action: PayloadAction<{ fieldName: string; value: any }>
) => {
  const { fieldName, value } = action.payload;
  return { ...state, [fieldName]: value };
};

export const setDurationReducer = (
  state: CampaignDetailSlice,
  action: PayloadAction<{ durationName: string }>
) => {
  const { durationName } = action.payload;
  return {
    ...state,
    [REDUX_KEY.CAMPAIGN_DURATIONS]: {
      ...state[REDUX_KEY.CAMPAIGN_DURATIONS],
      [durationName]: !state[REDUX_KEY.CAMPAIGN_DURATIONS][durationName]
    }
  };
};

export const setStartDateReducer = (
  state: CampaignDetailSlice,
  action: PayloadAction<{ date: string | undefined }>
) => {
  const { date } = action.payload;
  return {
    ...state,
    [REDUX_KEY.CAMPAIGN_LENGTH]: {
      ...state[REDUX_KEY.CAMPAIGN_LENGTH],
      startDate: date
    }
  };
};

export const setEndDateReducer = (
  state: CampaignDetailSlice,
  action: PayloadAction<{ date: string | undefined }>
) => {
  const { date } = action.payload;
  return {
    ...state,
    [REDUX_KEY.CAMPAIGN_LENGTH]: {
      ...state[REDUX_KEY.CAMPAIGN_LENGTH],
      [REDUX_KEY.CAMPAIGN_LENGTH_END_DATE]: date
    }
  };
};

export const setSelectedMonthReducer = (
  state: CampaignDetailSlice,
  action: PayloadAction<{ month: string }>
) => {
  const { month } = action.payload;
  return {
    ...state,
    [REDUX_KEY.SELECTED_MONTH]: month
  };
};
